import { useState } from 'react';

/**
 * Hook personnalisé pour gérer la liste des participants
 */
export const useParticipants = () => {
  const [participants, setParticipants] = useState([]);
  console.log('🔧 Participants:', participants);

  /**
   * Génère un ID unique pour un participant
   * @returns {string} ID unique
   */
  const generateParticipantId = () => {
    return `participant_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  };

  /**
   * Ajoute un participant à la liste
   * @param {Object} participant - Le participant à ajouter
   */
  const addParticipant = (participant) => {
    const newParticipant = {
      ...participant,
      id: generateParticipantId()
    };
    
    setParticipants(prev => [...prev, newParticipant]);
    return newParticipant;
  };

  /**
   * Supprime un participant de la liste
   * @param {number} participantId - L'ID du participant à supprimer
   */
  const removeParticipant = (participantId) => {
    setParticipants(prev => {
      const updated = prev.filter(p => p.id !== participantId);
      // Renuméroter les participants
      return updated.map((p, index) => ({
        ...p,
        number: index + 1
      }));
    });
  };

  /**
   * Réinitialise la liste des participants
   */
  const clearParticipants = () => {
    setParticipants([]);
  };

  /**
   * Crée un participant accompagnateur
   * @param {Object} data - Les données de l'accompagnateur
   * @returns {Object} Le participant créé
   */
  const createAccompanistParticipant = (data) => {
    const fullPhoneNumber = `${data.countryCode}${data.phoneNumber}`;
    
    return {
      id: generateParticipantId(),
      type: 'Accompagnateur',
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: fullPhoneNumber
    };
  };

  /**
   * Crée un participant futur soldat depuis un lead trouvé
   * @param {Object} lead - Le lead trouvé
   * @param {string} email - L'email du futur soldat
   * @returns {Object} Le participant créé
   */
  const createSoldierParticipantFromLead = (lead, email) => {
    return {
      id: generateParticipantId(),
      type: 'Futur soldat',
      firstName: lead.lead_firstName || '',
      lastName: lead.lead_lastName || '',
      phone: lead.lead_phoneNumber || '',
      email: email,
      leadId: lead.lead_ID || null
    };
  };

  /**
   * Crée un participant futur soldat manuel
   * @param {Object} data - Les données du futur soldat
   * @returns {Object} Le participant créé
   */
  const createSoldierParticipantManual = (data) => {
    const fullPhoneNumber = `${data.countryCode} ${data.phoneNumber}`;
    
    return {
      id: generateParticipantId(),
      type: 'Futur soldat',
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: fullPhoneNumber,
      leadId: null
    };
  };

  return {
    participants,
    addParticipant,
    removeParticipant,
    clearParticipants,
    createAccompanistParticipant,
    createSoldierParticipantFromLead,
    createSoldierParticipantManual
  };
};